import * as React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";

import Root from "./routing/Root";
import store from "./redux/store";

const rootEl = document.getElementById("root");

render(
  <Provider store={store}>
    <Root />
  </Provider>,
  rootEl,
);
